const reportTheme = {
  id: 308,
  name: "Horizontal Bar",
  slug: "horizontal-bar",
  title: null,
  description: null,
  clientID: 1,
  use_for_summary: false,
  allow_for_custom: false,
  country: "England",
};

const items = [
  {
    id: 4001,
    reportThemeID: 308,
    text: null,
    chartType: "Horizontal Bar",
    chartRef: "17274229378853",
    chartDescription: "Drug crime offences",
    chartXLabel: null,
    chartYLabel: null,
    syncChartWithHTMLTableRef: null,
    inverseChartData: true,
    chartXCommaSeperatedValues: null,
    chartYCommaSeperatedValues: null,
    indicatorHTMLTableRef: null,
    HTMLTableType: 1,
    indicatorHTMLTableDescription: null,
    domainHTMLTableColOneText: null,
    domainHTMLTableColTwoText: null,
    order: 1,
    timeSeries: true,
    itemName: null,
    itemSource: null,
    showComparators: true,
    kpi_config: null,
    display_data_point_markers: false,
    indicators: [
      {
        id: 7190,
        indicatorHTMLTableRef: null,
        chartRef: "17274229378853",
        indicatorCode: "drugs_police_uk_12_month",
        indicatorDate: "2020-11-01,2023-09-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 8,
        indicatorName: "Drug crime offences (rollling 12 month total)",
        source: "police.uk",
        date: "2020-12-01",
        decimalPlaces: 0,
        dateCoverageText: "Dec-2020 to Nov-2021",
      },
      {
        id: 7190,
        indicatorHTMLTableRef: null,
        chartRef: "17274229378853",
        indicatorCode: "drugs_police_uk_12_month",
        indicatorDate: "2020-11-01,2023-09-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 8,
        indicatorName: "Drug crime offences (rollling 12 month total)",
        source: "police.uk",
        date: "2021-03-01",
        decimalPlaces: 0,
        dateCoverageText: "Mar-2021 to Feb-2022",
      },
      {
        id: 7190,
        indicatorHTMLTableRef: null,
        chartRef: "17274229378853",
        indicatorCode: "drugs_police_uk_12_month",
        indicatorDate: "2020-11-01,2023-09-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 8,
        indicatorName: "Drug crime offences (rollling 12 month total)",
        source: "police.uk",
        date: "2021-06-01",
        decimalPlaces: 0,
        dateCoverageText: "Jun-2021 to May-2022",
      },
      {
        id: 7190,
        indicatorHTMLTableRef: null,
        chartRef: "17274229378853",
        indicatorCode: "drugs_police_uk_12_month",
        indicatorDate: "2020-11-01,2023-09-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 8,
        indicatorName: "Drug crime offences (rollling 12 month total)",
        source: "police.uk",
        date: "2021-09-01",
        decimalPlaces: 0,
        dateCoverageText: "Sep-2021 to Aug-2022",
      },
      {
        id: 7190,
        indicatorHTMLTableRef: null,
        chartRef: "17274229378853",
        indicatorCode: "drugs_police_uk_12_month",
        indicatorDate: "2020-11-01,2023-09-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 8,
        indicatorName: "Drug crime offences (rollling 12 month total)",
        source: "police.uk",
        date: "2021-12-01",
        decimalPlaces: 0,
        dateCoverageText: "Dec-2021 to Nov-2022",
      },
    ],
  },
  {
    id: 4002,
    reportThemeID: 308,
    text: null,
    chartType: "Horizontal Bar",
    chartRef: "17274229378854",
    chartDescription: "Drug crime offences (Custom 4 month)",
    chartXLabel: null,
    chartYLabel: null,
    syncChartWithHTMLTableRef: null,
    inverseChartData: true,
    chartXCommaSeperatedValues: null,
    chartYCommaSeperatedValues: null,
    indicatorHTMLTableRef: null,
    HTMLTableType: 1,
    indicatorHTMLTableDescription: null,
    domainHTMLTableColOneText: null,
    domainHTMLTableColTwoText: null,
    order: 1,
    timeSeries: true,
    itemName: null,
    itemSource: null,
    showComparators: true,
    kpi_config: null,
    display_data_point_markers: false,
    indicators: [
      {
        id: 7190,
        indicatorHTMLTableRef: null,
        chartRef: "17274229378854",
        indicatorCode: "drugs_police_uk_12_month",
        indicatorDate: "2020-11-01,2023-09-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 8,
        indicatorName: "Drug crime offences (Custom 4 month)",
        source: "police.uk",
        date: "2020-12-01",
        decimalPlaces: 0,
        dateCoverageText: "Dec-2020 to Nov-2021",
      },
      {
        id: 7190,
        indicatorHTMLTableRef: null,
        chartRef: "17274229378854",
        indicatorCode: "drugs_police_uk_12_month",
        indicatorDate: "2020-11-01,2023-09-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 8,
        indicatorName: "Drug crime offences (Custom 4 month)",
        source: "police.uk",
        date: "2021-03-01",
        decimalPlaces: 0,
        dateCoverageText: "Mar-2021 to Feb-2022",
      },
      {
        id: 7190,
        indicatorHTMLTableRef: null,
        chartRef: "17274229378854",
        indicatorCode: "drugs_police_uk_12_month",
        indicatorDate: "2020-11-01,2023-09-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 8,
        indicatorName: "Drug crime offences (Custom 4 month)",
        source: "police.uk",
        date: "2021-06-01",
        decimalPlaces: 0,
        dateCoverageText: "Jun-2021 to May-2022",
      },
      {
        id: 7190,
        indicatorHTMLTableRef: null,
        chartRef: "17274229378854",
        indicatorCode: "drugs_police_uk_12_month",
        indicatorDate: "2020-11-01,2023-09-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 8,
        indicatorName: "Drug crime offences (Custom 4 month)",
        source: "police.uk",
        date: "2021-09-01",
        decimalPlaces: 0,
        dateCoverageText: "Sep-2021 to Aug-2022",
      },
    ],
  },
];

const comparatorAreaCodes = ["CSTM5160", "E10000012", "E10000011"];

const comparatorsList = [
  { area_code: "CSTM5160", area_name: "Comparator 1" },
  { area_code: "E10000012", area_name: "Comparator 2" },
  { area_code: "E10000011", area_name: "Comparator 3" },
];

// Indicator values for all horizontal bar chart examples (time series data)
// Key pattern: <area>.<indicatorCode>.<date>.<indicatorName>
const indicatorValues = {
  // Example 1: Drug crime offences (full time series)
  "CSTM5160.drugs_police_uk_12_month.2020-12-01.Drug crime offences (rollling 12 month total)":
    "1,460",
  "E10000012.drugs_police_uk_12_month.2020-12-01.Drug crime offences (rollling 12 month total)":
    "206,407",
  "E10000011.drugs_police_uk_12_month.2020-12-01.Drug crime offences (rollling 12 month total)":
    "30,645",

  "CSTM5160.drugs_police_uk_12_month.2021-03-01.Drug crime offences (rollling 12 month total)":
    "1,520",
  "E10000012.drugs_police_uk_12_month.2021-03-01.Drug crime offences (rollling 12 month total)":
    "210,200",
  "E10000011.drugs_police_uk_12_month.2021-03-01.Drug crime offences (rollling 12 month total)":
    "32,100",

  "CSTM5160.drugs_police_uk_12_month.2021-06-01.Drug crime offences (rollling 12 month total)":
    "1,380",
  "E10000012.drugs_police_uk_12_month.2021-06-01.Drug crime offences (rollling 12 month total)":
    "198,500",
  "E10000011.drugs_police_uk_12_month.2021-06-01.Drug crime offences (rollling 12 month total)":
    "29,800",

  "CSTM5160.drugs_police_uk_12_month.2021-09-01.Drug crime offences (rollling 12 month total)":
    "1,620",
  "E10000012.drugs_police_uk_12_month.2021-09-01.Drug crime offences (rollling 12 month total)":
    "215,300",
  "E10000011.drugs_police_uk_12_month.2021-09-01.Drug crime offences (rollling 12 month total)":
    "33,200",

  "CSTM5160.drugs_police_uk_12_month.2021-12-01.Drug crime offences (rollling 12 month total)":
    "1,750",
  "E10000012.drugs_police_uk_12_month.2021-12-01.Drug crime offences (rollling 12 month total)":
    "225,100",
  "E10000011.drugs_police_uk_12_month.2021-12-01.Drug crime offences (rollling 12 month total)":
    "35,400",

  // Example 2: Drug crime offences (Custom 4 month) - same data but different chartRef
  "CSTM5160.drugs_police_uk_12_month.2020-12-01.Drug crime offences (Custom 4 month)":
    "1,460",
  "E10000012.drugs_police_uk_12_month.2020-12-01.Drug crime offences (Custom 4 month)":
    "206,407",
  "E10000011.drugs_police_uk_12_month.2020-12-01.Drug crime offences (Custom 4 month)":
    "30,645",

  "CSTM5160.drugs_police_uk_12_month.2021-03-01.Drug crime offences (Custom 4 month)":
    "1,520",
  "E10000012.drugs_police_uk_12_month.2021-03-01.Drug crime offences (Custom 4 month)":
    "210,200",
  "E10000011.drugs_police_uk_12_month.2021-03-01.Drug crime offences (Custom 4 month)":
    "32,100",

  "CSTM5160.drugs_police_uk_12_month.2021-06-01.Drug crime offences (Custom 4 month)":
    "1,380",
  "E10000012.drugs_police_uk_12_month.2021-06-01.Drug crime offences (Custom 4 month)":
    "198,500",
  "E10000011.drugs_police_uk_12_month.2021-06-01.Drug crime offences (Custom 4 month)":
    "29,800",

  "CSTM5160.drugs_police_uk_12_month.2021-09-01.Drug crime offences (Custom 4 month)":
    "1,620",
  "E10000012.drugs_police_uk_12_month.2021-09-01.Drug crime offences (Custom 4 month)":
    "215,300",
  "E10000011.drugs_police_uk_12_month.2021-09-01.Drug crime offences (Custom 4 month)":
    "33,200",
};

export default {
  reportTheme,
  items,
  indicatorValues,
  comparatorsList,
  comparatorAreaCodes,
};
